import React from 'react';
import { Link } from 'react-router-dom';
import './AdminLayout.css';

interface AdminPageHeaderProps {
  title: string;
  actionLabel?: string;
  actionTo?: string;
  onAction?: () => void;
}

export const AdminPageHeader: React.FC<AdminPageHeaderProps> = ({
  title,
  actionLabel,
  actionTo,
  onAction,
}) => (
  <div className="admin-page-header">
    <h1 className="admin-page-title">{title}</h1>
    {actionLabel && actionTo && (
      <Link to={actionTo} className="admin-btn admin-btn-primary" style={{ textDecoration: 'none' }}>
        {actionLabel}
      </Link>
    )}
    {actionLabel && onAction && !actionTo && (
      <button type="button" className="admin-btn admin-btn-primary" onClick={onAction}>
        {actionLabel}
      </button>
    )}
  </div>
);

export const ActiveBadge: React.FC<{ active: boolean }> = ({ active }) => (
  <span className={`admin-badge ${active ? 'admin-badge-active' : 'admin-badge-inactive'}`}>
    {active ? 'Activa' : 'Inactiva'}
  </span>
);

export const UserActiveBadge: React.FC<{ active: boolean }> = ({ active }) => (
  <span className={`admin-badge ${active ? 'admin-badge-active' : 'admin-badge-inactive'}`}>
    {active ? 'Activo' : 'Inactivo'}
  </span>
);

export const AdminLoading: React.FC = () => <div className="admin-loading">Cargando…</div>;

export const AdminEmpty: React.FC<{ message: string }> = ({ message }) => (
  <div className="admin-empty">{message}</div>
);

export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString('es-AR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export async function copyToClipboard(text: string): Promise<void> {
  await navigator.clipboard.writeText(text);
}

export function confirmAction(message: string): boolean {
  return window.confirm(message);
}
